// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-page {
  max-width: 1120px;
  margin: auto;
  padding: 28px 22px 70px;
  color: #232137;
}
.business-page h1 {
  margin: 15px 0 8px;
  font-size: clamp(26px, 4vw, 36px);
}
.business-page h2 {
  font-size: 22px;
  margin: 0 0 18px;
}
.business-page h3 {
  font-size: 17px;
}
.business-page button, .business-page input, .business-page select, .business-page textarea {
  font: inherit;
}
.business-page button {
  cursor: pointer;
}
.business-page button:disabled {
  opacity: 0.5;
  cursor: default;
}
.business-page button:focus-visible, .business-page a:focus-visible {
  outline: 3px solid #6177e7;
  outline-offset: 3px;
}
.business-page label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
}
.business-page input, .business-page select, .business-page textarea {
  border: 1px solid #dce1e8;
  border-radius: 10px;
  background: white;
  padding: 10px 12px;
  min-width: 0;
  max-width: 100%;
}
.business-page small {
  color: #6f7890;
}

.business-back {
  color: #6f7890;
  text-decoration: none;
  font-size: 14px;
}

.business-subtitle {
  color: #6f7890;
  margin: 0 0 25px;
  line-height: 1.6;
}

.business-toolbar {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  flex-wrap: wrap;
  margin: 22px 0;
}

.business-primary, .business-secondary {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-height: 44px;
  border-radius: 12px;
  padding: 11px 18px;
  border: 0;
  text-decoration: none;
  font-size: 14px;
}

.business-primary {
  color: white;
  background: #e72f44;
}

.business-secondary {
  background: #eef1f5;
  color: #232137;
}

.business-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 22px;
}

.business-metric {
  background: white;
  border: 1px solid #e5e8ee;
  border-radius: 18px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.business-metric > span {
  color: #6f7890;
  font-size: 13px;
}
.business-metric > strong {
  font-size: clamp(22px, 3vw, 30px);
}
.business-metric small {
  line-height: 1.5;
}

.business-card {
  background: white;
  border: 1px solid #e5e8ee;
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 20px;
}
.business-card > p {
  line-height: 1.6;
}

.business-error, .business-notice {
  padding: 16px;
  border-radius: 12px;
  background: #fff1e0;
  margin: 16px 0;
  line-height: 1.5;
}

.business-error {
  background: #fff0f2;
  color: #a71b34;
}

.business-table-wrap {
  overflow-x: auto;
}

.business-table {
  width: 100%;
  border-collapse: collapse;
}
.business-table th, .business-table td {
  text-align: left;
  padding: 14px 12px;
  border-bottom: 1px solid #edf0f3;
  font-size: 14px;
}
.business-table th {
  color: #6f7890;
  font-weight: 500;
}
.business-table td:first-child {
  font-weight: 600;
}

.business-list {
  display: grid;
  gap: 12px;
}

.business-row {
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  border-bottom: 1px solid #edf0f3;
}
.business-row p {
  margin: 6px 0;
  color: #6f7890;
}

.business-checklist {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.business-checklist label {
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 10px;
}

.business-method {
  line-height: 1.7;
}
.business-method summary {
  cursor: pointer;
  font-weight: 600;
}

.business-negative {
  color: #b0203a;
}

.business-positive {
  color: #14764c;
}

.quality-point {
  border: 1px solid #e5e8ee;
  border-radius: 12px;
  padding: 16px;
  margin: 18px 0;
  min-width: 0;
}
.quality-point legend {
  font-weight: 600;
  padding: 0 6px;
}
.quality-point summary {
  cursor: pointer;
}

.quality-review-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.business-bars {
  height: 220px;
  display: flex;
  align-items: flex-end;
  gap: 5px;
  padding: 16px 0 2px;
  overflow-x: auto;
}
.business-bars button {
  flex: 1 1;
  min-width: 8px;
  border: 0;
  padding: 0;
  border-radius: 5px 5px 0 0;
  background: #e72f44;
}
.business-bars button:hover, .business-bars button[aria-pressed=true] {
  background: #232137;
}

.business-chart-range {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #6f7890;
  margin-top: 10px;
}

@media (max-width: 650px) {
  .business-page {
    padding: 20px 14px 40px;
  }
  .business-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  .business-metric {
    padding: 16px;
  }
  .business-card {
    padding: 18px;
  }
  .business-toolbar > label {
    flex: 1 1;
  }
  .business-row {
    align-items: flex-start;
    flex-wrap: wrap;
  }
}
.campaign-poster {
  display: block;
  width: 100%;
  max-width: 800px;
  height: auto;
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  margin: 16px 0;
}

.assistant-answer {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  line-height: 1.6;
}`, "",{"version":3,"sources":["webpack://./src/pages/shared/business.scss"],"names":[],"mappings":"AAAA;EAAiB,iBAAA;EAAmB,YAAA;EAAc,uBAAA;EAAyB,cAAA;AAK3E;AAL2F;EAAK,kBAAA;EAAoB,iCAAA;AASpH;AATyJ;EAAK,eAAA;EAAiB,gBAAA;AAa/K;AAbmM;EAAK,eAAA;AAgBxM;AAhB2N;EAAkC,aAAA;AAmB7P;AAnB8Q;EAAS,eAAA;AAsBvR;AAtB0S;EAAkB,YAAA;EAAa,eAAA;AA0BzU;AA1B4V;EAAwC,0BAAA;EAA4B,mBAAA;AA8Bha;AA9Bub;EAAQ,aAAA;EAAe,sBAAA;EAAwB,QAAA;EAAU,eAAA;AAoChf;AApCmgB;EAA0B,yBAAA;EAA2B,mBAAA;EAAqB,iBAAA;EAAmB,kBAAA;EAAoB,YAAA;EAAc,eAAA;AA4CloB;AA5CqpB;EAAQ,cAAA;AA+C7pB;;AA9CA;EAAiB,cAAA;EAAgB,qBAAA;EAAuB,eAAA;AAoDxD;;AAnDA;EAAqB,cAAA;EAAgB,gBAAA;EAAkB,gBAAA;AAyDvD;;AAxDA;EAAoB,aAAA;EAAe,SAAA;EAAW,qBAAA;EAAuB,eAAA;EAAiB,cAAA;AAgEtF;;AA/DA;EAAyC,oBAAA;EAAsB,uBAAA;EAAyB,mBAAA;EAAqB,gBAAA;EAAkB,mBAAA;EAAqB,kBAAA;EAAoB,SAAA;EAAW,qBAAA;EAAuB,eAAA;AA2E1M;;AA1EA;EAAoB,YAAA;EAAc,mBAAA;AA+ElC;;AA9EA;EAAsB,mBAAA;EAAqB,cAAA;AAmF3C;;AAlFA;EAAoB,aAAA;EAAe,gDAAA;EAAkD,SAAA;EAAW,mBAAA;AAyFhG;;AAxFA;EAAmB,iBAAA;EAAmB,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,aAAA;EAAe,sBAAA;EAAwB,SAAA;AAkG5I;AAlGuJ;EAAS,cAAA;EAAgB,eAAA;AAsGhL;AAtGmM;EAAW,iCAAA;AAyG9M;AAzGmP;EAAQ,gBAAA;AA4G3P;;AA3GA;EAAiB,iBAAA;EAAmB,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,mBAAA;AAmHnG;AAnHwH;EAAM,gBAAA;AAsH9H;;AArHA;EAAoC,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,cAAA;EAAgB,gBAAA;AA6H7G;;AA5HA;EAAkB,mBAAA;EAAqB,cAAA;AAiIvC;;AAhIA;EAAuB,gBAAA;AAoIvB;;AAnIA;EAAkB,WAAA;EAAa,yBAAA;AAwI/B;AAxI0D;EAAS,gBAAA;EAAkB,kBAAA;EAAoB,gCAAA;EAAkC,eAAA;AA8I3I;AA9I8J;EAAK,cAAA;EAAgB,gBAAA;AAkJnL;AAlJuM;EAAiB,gBAAA;AAqJxN;;AApJA;EAAiB,aAAA;EAAe,SAAA;AAyJhC;;AAxJA;EAAgB,eAAA;EAAiB,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,SAAA;EAAW,gCAAA;AAiKhH;AAjKkJ;EAAI,aAAA;EAAe,cAAA;AAqKrK;;AApKA;EAAsB,aAAA;EAAe,SAAA;EAAW,eAAA;AA0KhD;AA1KiE;EAAQ,mBAAA;EAAqB,mBAAA;EAAqB,iBAAA;EAAmB,mBAAA;EAAqB,mBAAA;AAiL3J;;AAhLA;EAAmB,gBAAA;AAoLnB;AApLqC;EAAU,eAAA;EAAiB,gBAAA;AAwLhE;;AAvLA;EAAqB,cAAA;AA2LrB;;AA3LuC;EAAqB,cAAA;AA+L5D;;AA9LA;EAAiB,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,cAAA;EAAgB,YAAA;AAsMhG;AAtM8G;EAAS,gBAAA;EAAkB,cAAA;AA0MzI;AA1M2J;EAAU,eAAA;AA6MrK;;AA5MA;EAAuB,qBAAA;EAAuB,uBAAA;AAiN9C;;AAhNA;EAAiB,aAAA;EAAe,aAAA;EAAe,qBAAA;EAAuB,QAAA;EAAU,mBAAA;EAAqB,gBAAA;AAyNrG;AAzNuH;EAAS,SAAA;EAAS,cAAA;EAAgB,SAAA;EAAW,UAAA;EAAY,0BAAA;EAA4B,mBAAA;AAiO5M;AAjOiO;EAAkC,mBAAA;AAoOnQ;;AAnOA;EAAwB,aAAA;EAAe,8BAAA;EAAgC,eAAA;EAAiB,cAAA;EAAgB,gBAAA;AA2OxG;;AA1OA;EAA4B;IAAiB,uBAAA;EA+O3C;EA/OsE;IAAoB,gDAAA;IAAkD,SAAA;EAmP5I;EAnPyJ;IAAmB,aAAA;EAsP5K;EAtP6L;IAAiB,aAAA;EAyP9M;EAzP+N;IAA4B,SAAA;EA4P3P;EA5PsQ;IAAgB,uBAAA;IAAyB,eAAA;EAgQ/S;AACF;AA/PA;EAAmB,cAAA;EAAgB,WAAA;EAAa,gBAAA;EAAkB,YAAA;EAAc,yBAAA;EAA2B,mBAAA;EAAqB,cAAA;AAwQhI;;AAvQA;EAAoB,qBAAA;EAAuB,uBAAA;EAAyB,gBAAA;AA6QpE","sourcesContent":[".business-page { max-width: 1120px; margin: auto; padding: 28px 22px 70px; color: #232137; h1 { margin: 15px 0 8px; font-size: clamp(26px, 4vw, 36px); } h2 { font-size: 22px; margin: 0 0 18px; } h3 { font-size: 17px; } button, input, select, textarea { font: inherit; } button { cursor: pointer; } button:disabled { opacity: .5; cursor: default; } button:focus-visible, a:focus-visible { outline: 3px solid #6177e7; outline-offset: 3px; } label { display: flex; flex-direction: column; gap: 6px; font-size: 14px; } input, select, textarea { border: 1px solid #dce1e8; border-radius: 10px; background: white; padding: 10px 12px; min-width: 0; max-width: 100%; } small { color: #6f7890; } }\n.business-back { color: #6f7890; text-decoration: none; font-size: 14px; }\n.business-subtitle { color: #6f7890; margin: 0 0 25px; line-height: 1.6; }\n.business-toolbar { display: flex; gap: 12px; align-items: flex-end; flex-wrap: wrap; margin: 22px 0; }\n.business-primary, .business-secondary { display: inline-flex; justify-content: center; align-items: center; min-height: 44px; border-radius: 12px; padding: 11px 18px; border: 0; text-decoration: none; font-size: 14px; }\n.business-primary { color: white; background: #e72f44; }\n.business-secondary { background: #eef1f5; color: #232137; }\n.business-metrics { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 14px; margin-bottom: 22px; }\n.business-metric { background: white; border: 1px solid #e5e8ee; border-radius: 18px; padding: 22px; display: flex; flex-direction: column; gap: 12px; > span { color: #6f7890; font-size: 13px; } > strong { font-size: clamp(22px, 3vw, 30px); } small { line-height: 1.5; } }\n.business-card { background: white; border: 1px solid #e5e8ee; border-radius: 20px; padding: 24px; margin-bottom: 20px; > p { line-height: 1.6; } }\n.business-error, .business-notice { padding: 16px; border-radius: 12px; background: #fff1e0; margin: 16px 0; line-height: 1.5; }\n.business-error { background: #fff0f2; color: #a71b34; }\n.business-table-wrap { overflow-x: auto; }\n.business-table { width: 100%; border-collapse: collapse; th, td { text-align: left; padding: 14px 12px; border-bottom: 1px solid #edf0f3; font-size: 14px; } th { color: #6f7890; font-weight: 500; } td:first-child { font-weight: 600; } }\n.business-list { display: grid; gap: 12px; }\n.business-row { padding: 16px 0; display: flex; justify-content: space-between; align-items: center; gap: 15px; border-bottom: 1px solid #edf0f3; p { margin: 6px 0; color: #6f7890; } }\n.business-checklist { display: flex; gap: 12px; flex-wrap: wrap; label { flex-direction: row; align-items: center; padding: 8px 12px; background: #f5f7fa; border-radius: 10px; } }\n.business-method { line-height: 1.7; summary { cursor: pointer; font-weight: 600; } }\n.business-negative { color: #b0203a; } .business-positive { color: #14764c; }\n.quality-point { border: 1px solid #e5e8ee; border-radius: 12px; padding: 16px; margin: 18px 0; min-width: 0; legend { font-weight: 600; padding: 0 6px; } summary { cursor: pointer; } }\n.quality-review-text { white-space: pre-wrap; overflow-wrap: anywhere; }\n.business-bars { height: 220px; display: flex; align-items: flex-end; gap: 5px; padding: 16px 0 2px; overflow-x: auto; button { flex: 1; min-width: 8px; border: 0; padding: 0; border-radius: 5px 5px 0 0; background: #e72f44; &:hover, &[aria-pressed=\"true\"] { background: #232137; } } }\n.business-chart-range { display: flex; justify-content: space-between; font-size: 12px; color: #6f7890; margin-top: 10px; }\n@media (max-width: 650px) { .business-page { padding: 20px 14px 40px; } .business-metrics { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; } .business-metric { padding: 16px; } .business-card { padding: 18px; } .business-toolbar > label { flex: 1; } .business-row { align-items: flex-start; flex-wrap: wrap; } }\n\n.campaign-poster { display: block; width: 100%; max-width: 800px; height: auto; border: 1px solid #e6e6e6; border-radius: 12px; margin: 16px 0; }\n.assistant-answer { white-space: pre-wrap; overflow-wrap: anywhere; line-height: 1.6; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
